import {NavLink} from 'react-router-dom';
import {I18n} from '@aws-amplify/core';

import {
    Box,
    Breadcrumbs,
} from '@mantine/core';
import {ProductLineItem} from "../types.ts";

export const EditPageNavigation = ({component}: { component: ProductLineItem }) => {

    const breadcrumbs = [
        {
            title: I18n.get('Home'),
            href: '/dashboard',
        },
        {
            title: I18n.get('Products'),
            href: '/products',
        },
        {
            // The product's own page, whose Line Items tab lists this record.
            title: component.product?.name ?? component.productId,
            href: `/products/${component.productId}`,
        },
        {
            title: component.productFeature?.name ?? component.productFeatureId
        }
    ].map((item, index) => (
        <Box key={index}> {
            item
                .href ?
                <NavLink to={item.href}>{item.title}</NavLink> : item.title
        }
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
